/** Reader pages are vertically ordered and non-overlapping. Find the page
 * nearest the viewport midpoint without measuring every offscreen page.
 * A midpoint in a gap belongs to its nearest page; ties prefer the earlier one.
 */
export function nearestReaderPage<T>(
  pages: ArrayLike<T>,
  middle: number,
  bounds: (page: T) => { top: number; bottom: number },
): T | undefined {
  if (!pages.length || !Number.isFinite(middle)) return undefined;
  let low = 0,
    high = pages.length;
  while (low < high) {
    const index = low + Math.floor((high - low) / 2);
    if (bounds(pages[index]).bottom < middle) low = index + 1;
    else high = index;
  }
  if (low === pages.length) return pages[low - 1];
  const next = pages[low];
  if (low === 0) return next;
  const box = bounds(next);
  if (middle >= box.top) return next;
  const previous = pages[low - 1];
  return middle - bounds(previous).bottom <= box.top - middle ? previous : next;
}
